import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import './style/footer.scss';

library.add(fas);





class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }


    render() {




        return (
            <div className="cover-footer">
                <div className="cover">
                    <p className="txt-copy"><FontAwesomeIcon icon={['fas', 'copyright']} /> 2021 NIPPY MARKET</p>
                </div>
            </div>
        )
    }
}

export default Footer;
